import { environment } from '../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('GuestService', GuestService);

  GuestService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'GuestModalService',
    'WindowModalService',
  ];

  function GuestService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    GuestModalService,
    WindowModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'bookings';

    var service = {
      openBookingGuestDetailModal: openBookingGuestDetailModal,
      saveBookingGuest: saveBookingGuest,
      changeBookingGuestDefault: changeBookingGuestDefault,
      deleteBookingGuest: deleteBookingGuest,
      openAddGuestToBookingItem: openAddGuestToBookingItem,
      openCheckInGuestToItem: openCheckInGuestToItem,
      openAddBookingItemToGuest: openAddBookingItemToGuest,
      openCheckInGuest: openCheckInGuest,
      addBookingItemToGuest: addBookingItemToGuest,
      checkInGuestToBooking: checkInGuestToBooking,
      saveCheckInBookingItem: saveCheckInBookingItem,
    };

    return service;

    //////////

    function openBookingGuestDetailModal(guest, booking, mode, successCallback) {
      var originalItem = angular.copy(guest);

      var confirmCallback = function (response) {
        if (guest.id) {
          // Edit
          //guest = response; // not updating

          guest.name = response.name;
          guest.last_name = response.last_name;
          guest.type = response.type;
          guest.birthday = response.birthday;
          guest.gender = response.gender;
          guest.height = response.height;
          guest.height_unit = response.height_unit;
          guest.weight = response.weight;
          guest.weight_unit = response.weight_unit;
          guest.title = response.title;
          guest.phone = response.phone;
          guest.age = response.age;
          guest.is_main_guest = response.is_main_guest;

          utils.itemListChanged(response.id);
        }

        return successCallback(response);
      };

      GuestModalService.openBookingGuestDetailModal(originalItem, booking, mode, confirmCallback);
    }

    function saveBookingGuest(guest, bookingId) {
      var url = apiUrl + '/' + bookingId + '/guests';
      var method = 'post';

      if (guest.id) {
        // edit
        url += '/' + guest.id;
        method = 'put';
      }

      function success(response) {
        var msg = !guest.id ? 'GUEST_ADDED' : 'GUEST_MODIFIED';
        utils._successMsg($translate(msg));

        return response.data;
      }
      function failure(response) {
        return response.data;
      }

      return RestResource.request(method, url, { guest: guest }, success, failure);
    }

    function changeBookingGuestDefault(guest, bookingId, successCallback) {
      var url = apiUrl + '/' + bookingId + '/guests/' + guest.id;

      var params = {
        guest: {
          is_default: true,
        },
        set_default: true,
      };

      function success() {
        utils._successMsg($translate('MAIN_GUEST_CHANGED'));

        return successCallback();
      }
      function failure() {}

      return RestResource.request('put', url, params, success, failure);
    }

    function deleteBookingGuest(guest, bookingId, successCallback) {
      var params = {
        title: 'DELETE_GUEST',
        body: 'SURE_TO_DELETE_GUEST',
        successMsg: 'GUEST_DELETED',
      };

      var url = apiUrl + '/' + bookingId + '/guests/' + guest.id;
      utils.deleteItem(url, successCallback, params);
    }

    function addBookingItemToGuest(
      guests,
      bookingItemId,
      bookingItemServiceItemId,
      isBaseOnServiceItem
    ) {
      let url = `${environment.apiEndpoint}/guests`;
      url = isBaseOnServiceItem
        ? `${url}/add_booking_item_service_item_to_guest`
        : `${url}/add_booking_item_to_guest`;

      function success(response) {
        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      let params = {
        guests: guests,
        skip_check_role: true,
        booking_item_service_item_id: null,
        booking_item_id: null,
      };

      if (isBaseOnServiceItem) {
        params.booking_item_service_item_id = bookingItemServiceItemId;
      } else {
        params.booking_item_id = bookingItemId;
      }

      return RestResource.request('put', url, params, success, failure);
    }

    function checkInGuestToBooking(guest, notes) {
      let url = `${environment.apiEndpoint}/guests/check_in_booking`;

      function success(response) {
        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      let params = {
        guest: guest,
        id: guest.id,
        notes: notes,
        booking_id: guest.booking_id,
        skip_check_role: true,
      };

      return RestResource.request('put', url, params, success, failure);
    }

    function saveCheckInBookingItem(guests, notes, bookingId) {
      let url = `${environment.apiEndpoint}/guests/check_in_all_guest`;

      function success(response) {
        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      let params = {
        guests: guests,
        notes: notes,
        booking_id: bookingId,
        skip_check_role: true,
      };

      return RestResource.request('put', url, params, success, failure);
    }

    function openAddGuestToBookingItem(guest, booking, successCallback) {
      let templateUrl = './app/ajs/bookings/booking-guests/modals/add-guest-to-item-modal.html';
      let item = {
        guest: guest,
        booking: booking,
      };

      let modalParams = {
        item: item,
        closeOnSave: true,
        preventModalClose: true,
      };

      let confirmCallback = function (response) {
        successCallback(response);
        utils._successMsg($translate('GUEST_MODIFIED'));
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }

    function openCheckInGuestToItem(guest, booking, successCallback) {
      let templateUrl =
        './app/ajs/bookings/booking-guests/modals/check-in-guest-to-item-modal.html';
      let item = {
        guest: guest,
        booking: booking,
      };

      let modalParams = {
        item: item,
        closeOnSave: false,
        preventModalClose: true,
      };

      let confirmCallback = function (response) {
        successCallback(response);
        utils._successMsg($translate('GUEST_MODIFIED'));
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }

    function openAddBookingItemToGuest(
      bookingItem,
      bookingItemServiceItem,
      booking,
      successCallback
    ) {
      let templateUrl =
        './app/ajs/bookings/booking-guests/modals/add-booking-item-to-guest-modal.html';
      let item = {
        bookingItem: bookingItem,
        bookingItemServiceItem: bookingItemServiceItem,
        booking: booking,
      };

      let modalParams = {
        item: item,
        closeOnSave: true,
        preventModalClose: true,
      };

      let confirmCallback = function (response) {
        successCallback(response);
        utils._successMsg($translate('GUEST_MODIFIED'));
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }

    function openCheckInGuest(bookingItem, bookingItemServiceItem, booking, successCallback) {
      let templateUrl = './app/ajs/bookings/booking-guests/modals/check-in-guest-modal.html';

      let item = {
        bookingItem: bookingItem,
        bookingItemServiceItem: bookingItemServiceItem,
        booking: booking,
      };

      let modalParams = {
        item: item,
        closeOnSave: false,
        preventModalClose: true,
      };

      let confirmCallback = function (response) {
        successCallback(response);
        utils._successMsg($translate('GUEST_MODIFIED'));
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }
  }
})();
